export const TRIAL_URGENT_DAYS = 3;
